'use client';

import { ReactNode } from 'react';
import { useInstantSearch } from 'react-instantsearch';

interface EmptyQueryBoundaryProps {
  children?: ReactNode;
  fallback?: ReactNode;
}

export function EmptyQueryBoundary({ children, fallback }: EmptyQueryBoundaryProps) {
  const { indexUiState } = useInstantSearch();

  if (!indexUiState.query) {
    return (
      <>
        {fallback}
        <div hidden>{children ?? null}</div>
      </>
    );
  }

  return children ?? null;
}
